import EntryActionTypes from '../constants/EntryActionTypes';

const fetchListReportDataInCurrentList = () => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_FETCH,
});

const upsertListReportDataInCurrentList = (data) => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_UPSERT,
  payload: {
    data,
  },
});

const completeListReportDataInCurrentList = () => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_COMPLETE,
});

export default {
  fetchListReportDataInCurrentList,
  upsertListReportDataInCurrentList,
  completeListReportDataInCurrentList,
};
